module.exports = __webpack_public_path__ + "static/media/34-12.49800506.mp3";